import Link from '../Link'
import ResponseIcon from './ResponseIcon'
import ResponseImage from './ResponseImage'

function ResponseItem( { response } ) {
  const primaryContentType = ( () => {
    if ( response.audio_object ) {
      return 'sound'
    }
    
    if ( response.writing ) {
      return 'write'
    }
    
    if ( response.image_object ) {
      return 'photo'
    }
  } )()

  return (
    <Link href={ `/lets-share/${ response.id }` }>
      <ResponseImage image={ {
        objectKey: response.image_object,
        width: response.file_data?.image?.width,
        height: response.file_data?.image?.height,
      } }
      />
      <ResponseIcon type={ primaryContentType } />
    </Link>
  )
}

export default ResponseItem
